/**
 * > When using the esBuild API, all `process.env.NODE_ENV` expressions
 * > are automatically defined to `"production"` if all minification
 * > options are enabled and `"development"` otherwise. This only happens
 * > if `process`, `process.env`, and `process.env.NODE_ENV` are not already
 * > defined. This substitution is necessary to avoid code crashing instantly
 * > (since `process` is a Node API, not a web API).
 * > — https://esbuild.github.io/api/#platform
 */

const NODE_ENV = process.env.NODE_ENV
const IS_MOBILE = window.matchMedia('(any-pointer:coarse)').matches
const HAS_HIGH_CONTRAST = window.matchMedia('(forced-colors: active)').matches || window.matchMedia('(prefers-contrast: more)').matches
const PREFERS_REDUCED_MOTION = (() => {
    const prefersReducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion)');
    prefersReducedMotionMediaQuery.addEventListener('change', () => { window.location.reload() });
    return prefersReducedMotionMediaQuery.matches;
})();

// Main environment variables
const ENV = Object.freeze({
    // Node environment
    NAME: NODE_ENV,
    IS_PROD: NODE_ENV === 'production',
    IS_DEV: NODE_ENV === 'development',
    HAS_HIGH_CONTRAST,

    // Device
    IS_MOBILE,
    IS_DESKTOP: !IS_MOBILE,
    PREFERS_REDUCED_MOTION,

    // Supports
    SUPPORTS_VH: (
        'CSS' in window
        && 'supports' in window.CSS
        && window.CSS.supports('height: 100svh')
        && window.CSS.supports('height: 100dvh')
        && window.CSS.supports('height: 100lvh')
    )
})

// Main CSS classes used within the project
const CSS_CLASS = Object.freeze({
    LOADING: 'is-loading',
    FIRST_LOADED: 'is-first-loaded',
    LOADED: 'is-loaded',
    READY: 'is-ready',
    FONTS_LOADED: 'fonts-loaded',
    LAZY_CONTAINER: 'c-lazy',
    LAZY_LOADED: '-lazy-loaded',
    MODAL_OPEN: 'has-modal-open',
    SHOWREEL_OPEN: 'has-showreel-open',
    NEXT_PROJECT_VISIBLE: 'is-next-project-visible',
})

// Custom js events
const CUSTOM_EVENT = Object.freeze({
    RESIZE_END: 'loco.resizeEnd',
    RESIZE: 'loco.resize',
    MENU_OPEN: 'menu.open',
    VISIT_START: 'visit.start',
    FRAGMENT_VISIT_END: 'fragment.visit.end',
    VISIT_END: 'visit.end',
})

// Fonts parameters
const FONT = Object.freeze({
    EAGER: [
        { family: 'Eigerdals', style: 'normal', weight: 800 },
        { family: 'Eigerdals', style: 'normal', weight: 900 },
    ],
})

// CSS Breakpoints
const BREAKPOINTS = Object.freeze({
    FROM_SM: 700,
    TO_SM: 699,
})

export {
    ENV,
    CSS_CLASS,
    CUSTOM_EVENT,
    FONT,
    BREAKPOINTS
}